<div class="row">
  <div class="col-12">
    <div class="home-details">
      <h5 class="home-title">{{category | titlecase}}</h5>
      <p class="home-subtitle">List of all {{category}} pages</p>
    </div>
  </div>
</div>

<app-segmented-tabs
  class="mt-3"
  [tabs]="tabOptions[type]"
  [activeTab]="activeTab"
  [ariaLabel]="category + ' pages'"
></app-segmented-tabs>
